// extracted by mini-css-extract-plugin
export default {"page":"LegalPage_page__kn3jy","back":"LegalPage_back__M7gNW","title":"LegalPage_title__OFog2","section":"LegalPage_section__frThY","list":"LegalPage_list__E+vEW"};